import {
  GET_MIXED_POI_BY_CITY
} from '../../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE,
  END
} from '../../../utils/status';


const INIT_STATE = {
  status: undefined,
  nextPage: undefined,
  data: []
};


export function select(state, key) {
  let mixedPois = state.poi.mixedPois;

  if (!key) {
    return mixedPois;
  } else {
    return mixedPois[key];
  }
}

export default function reducer(state = INIT_STATE, action) {
  let nextState;
  if (action.type === GET_MIXED_POI_BY_CITY) {
    switch (action.status) {
      case PENDING:
        nextState = {
          ...state,
          status: action.status,
          nextPage: action.nextPage
        };
        break;
      case FAILURE:
        nextState = {
          ...state,
          status: action.status,
          nextPage: action.nextPage,
          data: []
        };
        break;
      case SUCCESS:
      case END:
        nextState = {
          ...state,
          status: action.status,
          nextPage: action.data.next_page
        };
       
        if (state.poiType !== action.poiType || state.cityId !== action.cityId) {
          nextState.data = action.data.list;
          nextState.poiType = action.poiType;
          nextState.cityId = action.cityId;
        } else {
          nextState.data = state.data.concat(action.data.list);
        }

        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/poi/mixedPois.js